<template>
  <article class="profile">
    <section class="profile__account">
    <form @submit.prevent="update"
          @keydown="form.onKeydown($event)"
          data-vv-scope="password"
          class="password-form form">
      <alert-success :form="form" message="Новый пароль установлен"></alert-success>

      <div class="form__field">
        <label class="form__label">Новый пароль</label>
        <div class="form__input-wrapper">
          <input v-model="form.password"
                 v-validate="'required|min:6'"
                 type="password"
                 name="password"
                 autocomplete="off"
                 class="form__input"
                 :class="{'is-danger': errors.has('password.password') }">
          <span v-show="errors.has('password.password')" class="form__alert form__alert--error">{{ errors.first('password.password') }}</span>
        </div>
      </div>

      <div class="form__field">
        <label class="form__label">Подтвердите пароль</label>
        <div class="form__input-wrapper">
          <input v-model="form.password_confirmation"
                 v-validate="'required|min:6'"
                 type="password"
                 name="password_confirmation"
                 autocomplete="off"
                 class="form__input"
                 :class="{'is-danger': errors.has('password.password_confirmation') }">
          <span v-show="errors.has('password.password_confirmation')" class="form__alert form__alert--error">{{ errors.first('password.password_confirmation') }}</span>
        </div>
      </div>

      <v-button class="form__button button button--blue" type="submit" :loading="form.busy">{{ $t('update') }}</v-button>
    </form>
    </section>
  </article>
</template>

<script>
import Form from 'vform'

export default {
  scrollToTop: false,

  metaInfo () {
    return { title: 'Смена пароля' }
  },

  data: () => ({
    form: new Form({
      password: '',
      password_confirmation: ''
    })
  }),

  methods: {
    async update () {
      await this.form.patch('/api/settings/password')

      this.form.reset()
    }
  },
  beforeMount() {
    this.$store.dispatch('pages/setBreadcrumbs', [
      {
        title: 'Главная',
        route: { name: 'home' }
      },
      {
        title: 'Смена пароля',
      }
    ]);
  }
}
</script>
